import { colors } from 'ui/theme';

export const NOTE_CORNER_SIZE = 29;

export const NoteCorner = ({
  height = NOTE_CORNER_SIZE,
  width = NOTE_CORNER_SIZE,
  fill = colors.mustard10,
  stroke = colors.mustard100,
  ...props
}) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" {...props}>
    <path
      d="M0.607418 26.8555L0.60742 4.06262C0.60742 2.12962 2.17443 0.56262 4.10742 0.56262L26.9003 0.562622L0.607418 26.8555Z"
      fill={fill}
      stroke={stroke}
    />
  </svg>
);
